namespace uh.ui {

    export class UI extends Phaser.GameObjects.Container {

        private score:Phaser.GameObjects.DOMElement;
        private best:Phaser.GameObjects.DOMElement;
        private distance:Phaser.GameObjects.DOMElement;
        private powerUps:Phaser.GameObjects.DOMElement;
        private time:Phaser.GameObjects.DOMElement;
        private clickToPlay:Phaser.GameObjects.DOMElement;
        private copyrightEtc:Phaser.GameObjects.DOMElement;

        private titleScreenObstacle_Right:Phaser.GameObjects.Image;
        private titleScreenObstacle_Left:Phaser.GameObjects.Image;
        private uh_logo:Phaser.GameObjects.Image;
        private ctr_logo:Phaser.GameObjects.Image;
        private popup_icons:Phaser.GameObjects.Image;

        constructor(parent) {
            super(parent);

            this.score = this.scene.add.dom(0, 0, document.createElement('div'));
            this.score.node["style"].display = "none";
            this.score.skewX = -0.4;
            this.score.angle = -8;
            this.add(this.score);
            this.setScore(19);
            this.score["-scale-"] = 1;

            this.best = this.scene.add.dom(0, 0, document.createElement('div'));
            this.best.node["style"].display = "none";
            this.best.skewX = -0.4;
            this.best.angle = -8;
            this.add(this.best);
            this.setBest(747569);

            this.distance = this.scene.add.dom(0, 0, document.createElement('div'));
            this.distance.node["style"].display = "none";
            this.distance.skewX = -0.4;
            this.add(this.distance);
            this.setDistance(10.9);

            this.powerUps = this.scene.add.dom(0, 0, document.createElement('div'));
            this.powerUps.node["style"].display = "none";
            this.powerUps.skewX = -0.4;
            this.add(this.powerUps);
            this.setPowerUps(2);

            this.time = this.scene.add.dom(0, 0, document.createElement('div'));
            this.time.node["style"].display = "none";
            this.time.skewX = -0.4;
            this.time.angle = -8;
            this.time["-scale-"] = 1;
            this.add(this.time);
            this.setTime(17);

            this.clickToPlay = this.scene.add.dom(0, 0, document.createElement('div'));
            this.clickToPlay.node["style"].display = "none";
            this.clickToPlay.skewX = -0.4;
            this.add(this.clickToPlay);
            this.clickToPlay.node.innerHTML = '<span style="font: 40px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;display: flex;justify-content: center;flex-direction: column;text-align: center;">CLICK TO PLAY</span>';

            this.copyrightEtc = this.scene.add.dom(0, 0, document.createElement('div'));
            this.copyrightEtc.node["style"].display = "none";
            this.add(this.copyrightEtc);
            this.copyrightEtc.node.innerHTML = '<span style="font: 20px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;display: flex;justify-content: center;flex-direction: column;text-align: center;">ⓒ 2021 CENTRAL CORPORATION COPYRIGHT. ALL RIGHTS RESERVED.</span>';

            this.popup_icons = this.scene.add.image(0, 0, 'texture-atlas', 'popup_icons' + '0000');
            this.popup_icons.setOrigin(1, 0.5);
            this.add(this.popup_icons);

            this.titleScreenObstacle_Right = this.scene.add.image(0, 0, 'texture-atlas', 'titleScreenObstacle' + '0000');
            this.titleScreenObstacle_Right.setOrigin(0.5, 0.5);
            this.titleScreenObstacle_Right.flipX = true;
            this.add(this.titleScreenObstacle_Right);

            this.titleScreenObstacle_Left = this.scene.add.image(0, 0, 'texture-atlas', 'titleScreenObstacle' + '0000');
            this.titleScreenObstacle_Left.setOrigin(0.5, 0.5);
            this.add(this.titleScreenObstacle_Left);

            this.uh_logo = this.scene.add.image(0, 0, 'texture-atlas', 'uh_logo' + '0000');
            this.uh_logo.setOrigin(0.5, 0.5);
            this.add(this.uh_logo);

            this.ctr_logo = this.scene.add.image(0, 0, 'texture-atlas', 'ctr_logo' + '0000');
            this.ctr_logo.setOrigin(0.5, 0.5);
            this.add(this.ctr_logo);

            window["ui"]=this;
        }

        private timesupPopup:Phaser.GameObjects.Container = null;
        public showTimesUp(score:number, distance:number, onTryAgainClicked:()=>void):void {
            this.timesupPopup = this.scene.add.container(0, 0);
            this.add(this.timesupPopup);
            this.timesupPopup["-scale-"] = 1.5;
            this.timesupPopup.alpha = 0;
            this.scene.tweens.add({
                targets: this.timesupPopup,
                "-scale-": 1,
                alpha: 1,
                duration: 500
            });

            let timesup_popup:Phaser.GameObjects.Image = this.scene.add.image(0, 0, 'texture-atlas', 'timesup_popup' + '0000');
            timesup_popup.setOrigin(0.5, 0.5);
            this.timesupPopup.add(timesup_popup);

            let onDownAnim = (btn)=>{
                btn.scale = 1;
                this.scene.tweens.add({
                    targets: btn,
                    scale: 0.9,
                    yoyo:true,
                    duration: 150
                });
            };

            let btn_tryagain:Phaser.GameObjects.Image = this.scene.add.image(0, (105-49)*uh.App.ART_SCALE, 'texture-atlas', 'btn_tryagain' + '0000');
            btn_tryagain.setOrigin(0.5, 0.5);
            btn_tryagain.setInteractive({cursor:"pointer"});
            this.timesupPopup.add(btn_tryagain);
            btn_tryagain.once('pointerdown', ()=>{
                onDownAnim(btn_tryagain);
                onTryAgainClicked();
            });

            let btn_learnmore:Phaser.GameObjects.Image = this.scene.add.image(0, (208-49)*uh.App.ART_SCALE, 'texture-atlas', 'btn_learnmore' + '0000');
            btn_learnmore.setOrigin(0.5, 0.5);
            btn_learnmore.setInteractive({cursor:"pointer"});
            this.timesupPopup.add(btn_learnmore);
            btn_learnmore.on('pointerdown', ()=>{
                onDownAnim(btn_learnmore);

                window.open("https://aftermarket.ctr.co.kr/UnseenHeroes", "_blank");
            });

            let btn_fbshare:Phaser.GameObjects.Image = this.scene.add.image(0, (311-49)*uh.App.ART_SCALE, 'texture-atlas', 'btn_fbshare' + '0000');
            btn_fbshare.setOrigin(0.5, 0.5);
            btn_fbshare.setInteractive({cursor:"pointer"});
            this.timesupPopup.add(btn_fbshare);
            btn_fbshare.on('pointerdown', ()=>{
                onDownAnim(btn_fbshare);

                let quote:string = "CTR is calling all Unseen Heroes! I just got a high score of " + score + "! Got what it takes to beat my high score?";
                window.open("https://www.facebook.com/sharer/sharer.php?" +
                    "kid_directed_site=0" +
                    "&sdk=joey" +
                    "&u=" + "https://aftermarket.ctr.co.kr/game/" +
                    "&display=popup" +
                    "&ref=plugin" +
                    "&quote=" + quote +
                    "&src=share_button",
                    "sharerPopUp", "height=400,width=400");
            });

            let btn_ss:Phaser.GameObjects.Image = this.scene.add.image(0, 365*uh.App.ART_SCALE, 'texture-atlas', 'btn_ss' + '0000');
            btn_ss.setOrigin(0.5, 0.5);
            this.timesupPopup.add(btn_ss);

            let timesupPopupScoredTF:Phaser.GameObjects.Text = this.scene.add.text(0, -150*uh.App.ART_SCALE, String(score), {
                "fontFamily": "Lo-Res",
                "fontSize": 160*uh.App.ART_SCALE,
                "color": "#FFFFFF",
                "align": 'center'
            });
            timesupPopupScoredTF.setOrigin(0.5, 0.5);
            this.timesupPopup.add(timesupPopupScoredTF);

            let timesupPopupDistanceTF:Phaser.GameObjects.Text = this.scene.add.text(-55*uh.App.ART_SCALE, -34*uh.App.ART_SCALE, distance+' KM', {
                "fontFamily": "Lo-Res",
                "fontSize": 60*uh.App.ART_SCALE,
                "color": "#FFFFFF",
                "align": 'center'
            });
            timesupPopupDistanceTF.setOrigin(0, 0.5);
            this.timesupPopup.add(timesupPopupDistanceTF);
        }

        public hideTimesUp():void {
            this.remove(this.timesupPopup, true);
            this.timesupPopup = null;
        }

        public showBonusSecGained(x:number, y:number, totalAnimDuration:number, bonus:number):void {
            let tf:Phaser.GameObjects.Text = this.scene.add.text(x, y, "+"+String(bonus), {
                "fontFamily": "Lo-Res",
                "fontSize": 40,
                "color": "#FFFFFF",
                "align": 'center'
            });
            tf.setOrigin(0.5, 1);
            this.add(tf);

            this.scene.tweens.add({
                targets: tf,
                alpha: 0,
                duration: totalAnimDuration * 1.05,
                ease:Phaser.Math.Easing.Circular.In
            });
            this.scene.tweens.add({
                targets: tf,
                x: this.score.x,
                y: this.score.y,
                duration: totalAnimDuration,
                ease:Phaser.Math.Easing.Circular.In,
                onComplete: ()=>{
                    tf.destroy(true);
                    this.animateScoreIconScale();
                }
            });
        }

        public animateScoreIconScale():void {
            this.scene.tweens.killTweensOf(this.score);
            this.score["-scale-"] = 1;
            this.scene.tweens.add({
                targets: this.score,
                "-scale-": 1.35,
                duration: 200,
                yoyo: true
            });
        }

        public animateTimeIconScale(duration:number, repeat:number = 0, yoyo:boolean = true):void {
            this.scene.tweens.killTweensOf(this.time);
            this.time["-scale-"] = 1;
            this.time["alpha"] = 1;
            this.scene.tweens.add({
                targets: this.time,
                "-scale-": 1.25,
                "alpha": 0.15,
                duration: duration,
                yoyo: yoyo,
                repeat: repeat,
                onComplete:()=>{
                    this.time["alpha"] = 1;
                }
            });
        }

        private howFarMessage:Phaser.GameObjects.Image = null;
        public showHowFarMessage():void {
            this.howFarMessage = this.scene.add.image(0, 0, 'texture-atlas', 'hf_message' + '0000');
            this.howFarMessage.setOrigin(0.48, 0.5);
            this.add(this.howFarMessage);
        }

        public hideHowFarMessage():void {
            this.remove(this.howFarMessage, true);
            this.howFarMessage = null;
        }

        private icon_123:Phaser.GameObjects.Image = null;
        public showIcon321(onComplete:()=>void): void {
            let animate = (frame:string)=>{
                this.icon_123.setFrame(frame);
                this.icon_123.alpha = 0;
                this.icon_123["-scale-"] = 1.5;
                this.scene.tweens.add({
                    targets: this.icon_123,
                    "-scale-": 1,
                    alpha: 1,
                    duration: 500
                });
            };

            this.icon_123 = this.scene.add.image(0, 0, "texture-atlas", 'countdown_3' + '0000');
            this.add(this.icon_123);
            this.icon_123["-scale-"] = 1;
            animate('countdown_3' + '0000');
            uh.util.Functions.delayedCall(1000, () => {
                animate('countdown_2' + '0000');
                uh.util.Functions.delayedCall(1000, () => {
                    animate('countdown_1' + '0000');
                    uh.util.Functions.delayedCall(900, () => {
                        animate('countdown_go' + '0000');
                        uh.util.Functions.delayedCall(1000, () => {
                            this.icon_123.destroy(true);
                            this.icon_123 = null;

                            onComplete();
                        });
                    });
                });
            });

            uh.sound.SoundManager.getInstance().playSound('321go', 0.25);
        }

        private isTitleScreenShown:boolean = false;
        public showTitleScreen():void {
            this.isTitleScreenShown = true;
            this.showHowFarMessage();
        }
        public hideTitleScreen():void {
            this.isTitleScreenShown = false;
            this.hideHowFarMessage();
        }

        public setScore(score:number):void {
            this.score.node.innerHTML = '<span style="font: 50px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;">SCORE&nbsp;&nbsp;&nbsp;</span><span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">'+uh.util.Functions.padBack(score, 10, '&nbsp;')+'</span>';
        }

        public setBest(best:number):void {
            this.best.node.innerHTML = '<span style="font: 50px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;">BEST&nbsp;&nbsp;&nbsp;</span><span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">'+uh.util.Functions.padBack(best, 10, '&nbsp;')+'</span>';
        }

        public setDistance(distance:number):void {
            this.distance.node.innerHTML = '<span style="font: 50px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;">DISTANCE&nbsp;&nbsp;&nbsp;</span><span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">'
                +uh.util.Functions.padBack(distance.toFixed(2) + '&nbsp;KM', 10, '&nbsp;')
                +'</span>';
        }

        public setPowerUps(xNum:number):void {
            this.powerUps.node.innerHTML = '<span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">&nbsp;'+uh.util.Functions.padBack(xNum, 15, '&nbsp;')+'</span>';
        }

        private currentTime:number = -1;
        public setTime(seconds:number):void {
            this.currentTime = seconds;
            this.time.node.innerHTML = '<span style="font: 100px Noto Sans Bold; color: #FF0000; cursor:default; vertical-align: middle;-webkit-text-stroke: 2px black;line-height:0px;">'
                +(seconds == 0 ? 'TIME\'S' : 'TIME')
                +'<br/></span><span style="font: 240px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;-webkit-text-stroke: 4px black;">'

                +(seconds == 0 ? 'UP!' : uh.util.Functions.pad(seconds, 2, 0))
                +'</span>';
        }

        public resize(scaleFactor:number, sideRectWidths:number, timeWidthPercentage:number):void {
            let sidePercentage:number = sideRectWidths / this.scene.scale.width;
            let landscapeMode:boolean = sidePercentage > 0.25;

            if (this.isTitleScreenShown) {
                this.score.visible = this.best.visible = this.distance.visible = this.powerUps.visible = this.time.visible = this.popup_icons.visible = false;
                this.uh_logo.visible = this.ctr_logo.visible = true;
                this.clickToPlay.visible = this.copyrightEtc.visible = this.titleScreenObstacle_Right.visible = this.titleScreenObstacle_Left.visible = true;

                if (landscapeMode) {
                    let superWidthScaleFactor:number = sidePercentage > 0.4 ? Math.pow(1 - sidePercentage, 2) : 1;

                    this.uh_logo.setScale(this.scene.scale.width * 0.45 / this.uh_logo.width * superWidthScaleFactor);
                    this.ctr_logo.setScale(this.scene.scale.width * 0.15 / this.ctr_logo.width * superWidthScaleFactor);
                    this.titleScreenObstacle_Right.setScale(this.scene.scale.width * 0.4 / this.titleScreenObstacle_Right.width * superWidthScaleFactor);
                    this.titleScreenObstacle_Left.setScale(this.scene.scale.width * 0.4 / this.titleScreenObstacle_Left.width * superWidthScaleFactor);
                    this.clickToPlay.setScale(this.scene.scale.width * 0.2 / this.clickToPlay.node.clientWidth * superWidthScaleFactor);
                    this.copyrightEtc.setScale(this.scene.scale.width * 0.25 / this.copyrightEtc.node.clientWidth * superWidthScaleFactor);
                    this.howFarMessage.setScale(this.scene.scale.width * 0.33 / this.howFarMessage.width * superWidthScaleFactor);

                    this.uh_logo.setPosition(this.scene.scale.width * 0.5, this.scene.scale.height * 0.4);
                    this.howFarMessage.setPosition(this.scene.scale.width / 2, this.scene.scale.height * 0.79);
                    this.clickToPlay.setPosition(this.scene.scale.width * 0.5 - (this.clickToPlay.node.clientWidth * this.clickToPlay.scaleX * 0.5), this.scene.scale.height * 0.88);
                    this.copyrightEtc.setPosition(this.scene.scale.width * 0.5 - (this.copyrightEtc.node.clientWidth * this.copyrightEtc.scaleX * 0.5), this.scene.scale.height * 0.96);
                } else {
                    this.uh_logo.setScale(this.scene.scale.width * 0.6 / this.uh_logo.width);
                    this.ctr_logo.setScale(this.scene.scale.width * 0.25 / this.ctr_logo.width);
                    this.titleScreenObstacle_Right.setScale(this.scene.scale.width * 0.3 / this.titleScreenObstacle_Right.width);
                    this.titleScreenObstacle_Left.setScale(this.scene.scale.width * 0.3 / this.titleScreenObstacle_Left.width);
                    this.clickToPlay.setScale(this.scene.scale.width * 0.3 / this.clickToPlay.node.clientWidth);
                    this.copyrightEtc.setScale(this.scene.scale.width * 0.35 / this.copyrightEtc.node.clientWidth);
                    this.howFarMessage.setScale(this.scene.scale.width * 0.9 / this.howFarMessage.width);

                    this.uh_logo.setPosition(this.scene.scale.width * 0.5, this.scene.scale.height * 0.5);
                    this.howFarMessage.setPosition(this.scene.scale.width / 2, this.scene.scale.height * 0.75);
                    this.clickToPlay.setPosition(this.scene.scale.width * 0.5 - (this.clickToPlay.node.clientWidth * this.clickToPlay.scaleX * 0.5), this.scene.scale.height * 0.83);
                    this.copyrightEtc.setPosition(this.scene.scale.width * 0.5 - (this.copyrightEtc.node.clientWidth * this.copyrightEtc.scaleX * 0.5), this.scene.scale.height * 0.93);
                }

                this.ctr_logo.setPosition(this.scene.scale.width * 0.5, this.scene.scale.height * 0.05 + this.ctr_logo.height * this.ctr_logo.scaleY * 0.5);
                this.titleScreenObstacle_Right.setPosition(this.scene.scale.width, this.scene.scale.height * 0.5);
                this.titleScreenObstacle_Left.setPosition(0, this.scene.scale.height * 0.5);

                return;
            }

            this.clickToPlay.visible = this.copyrightEtc.visible = this.titleScreenObstacle_Right.visible = this.titleScreenObstacle_Left.visible = false;
            this.score.visible = this.best.visible = this.distance.visible = this.powerUps.visible = this.time.visible = this.popup_icons.visible = true;

            let attentionUpScale:number = this.currentTime <= 5 ? 1.25 : 1;
            this.time.setScale(this.time["-scale-"] * this.scene.scale.width * timeWidthPercentage / this.time.node.clientWidth * attentionUpScale);

            if (landscapeMode) {
                this.distance.angle = 0;

                let coefficient:number = Math.pow(1 - sidePercentage, 2.5);
                this.score.setScale(this.score["-scale-"] * (sideRectWidths * coefficient / this.score.node.clientWidth));
                this.best.setScale(sideRectWidths * coefficient / this.best.node.clientWidth);
                this.distance.setScale(sideRectWidths * coefficient / this.distance.node.clientWidth);
                this.powerUps.setScale(sideRectWidths * coefficient / this.powerUps.node.clientWidth);

                this.uh_logo.setScale(sideRectWidths * 0.65 / this.uh_logo.width);
                this.ctr_logo.setScale(sideRectWidths * 0.5 / this.ctr_logo.width);
                this.popup_icons.setScale(sideRectWidths * 0.3 / this.popup_icons.width);

                this.time.setPosition(this.scene.scale.width / 2 - (this.time.node.clientWidth * this.time.scaleX * 0.35), this.scene.scale.height * 0.05);
                this.score.setPosition(sideRectWidths *  0.5 - (this.score.node.clientWidth * this.score.scaleX * 0.5), this.scene.scale.height * 0.05);
                this.best.setPosition(this.scene.scale.width - sideRectWidths *  0.5 - (this.best.node.clientWidth * this.best.scaleX * 0.5), this.scene.scale.height * 0.05);
                this.distance.setPosition(sideRectWidths *  0.5 - (this.distance.node.clientWidth * this.distance.scaleX * 0.5), this.scene.scale.height * 0.95 - (this.distance.node.clientHeight * this.distance.scaleY * 0.5));
                this.powerUps.setPosition(this.scene.scale.width - sideRectWidths *  0.45, this.scene.scale.height * 0.95 - (this.powerUps.node.clientHeight * this.powerUps.scaleY * 0.5));

                this.uh_logo.visible = this.ctr_logo.visible = this.popup_icons.visible = this.powerUps.visible = true;

                this.uh_logo.setPosition(sideRectWidths * 0.5, this.scene.scale.height * 0.5);
                this.ctr_logo.setPosition(this.scene.scale.width - sideRectWidths * 0.5, this.scene.scale.height * 0.5);
                this.popup_icons.setPosition(this.scene.scale.width - sideRectWidths * 0.5, this.scene.scale.height * 0.95);
            } else {
                this.distance.angle = -8;

                this.score.setScale(this.score["-scale-"] * (this.scene.scale.width * 0.4 / this.score.node.clientWidth));
                this.best.setScale(this.scene.scale.width * 0.4 / this.best.node.clientWidth);
                this.distance.setScale(this.scene.scale.width * 0.4 / this.distance.node.clientWidth);

                this.time.setPosition(this.scene.scale.width * 0.95 - (this.time.node.clientWidth * this.time.scaleX), this.scene.scale.height * 0.05);
                this.score.setPosition(this.scene.scale.width *  0.1, this.scene.scale.height * 0.035);
                this.best.setPosition(this.scene.scale.width *  0.1, this.scene.scale.height * 0.085);
                this.distance.setPosition(this.scene.scale.width * 0.1, this.scene.scale.height * 0.135);

                this.uh_logo.visible = this.ctr_logo.visible = this.popup_icons.visible = this.powerUps.visible = false;
            }

            if (this.timesupPopup) {
                this.timesupPopup.setScale(this.timesupPopup["-scale-"] * scaleFactor);
                this.timesupPopup.setPosition(this.scene.scale.width / 2, this.scene.scale.height / 2);
            }

            if (this.icon_123) {
                this.icon_123.setScale(this.icon_123["-scale-"] * scaleFactor);
                this.icon_123.setPosition(this.scene.scale.width / 2, this.scene.scale.height / 2);
            }
        }
    }
}